/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ResourceProcessJobParams } from './resourceProcessJobParams';

/**
 * Request model for resource processing job
 */
export interface RunResourceProcessJobRequest {
  type: 'process_resource';
  params: ResourceProcessJobParams;
  allowOverlappingJobs?: boolean;
}
